module.exports = __webpack_public_path__ + "img/set_theme_7.cbd540b9.png";